<template>
  <div>
    <TempPageVue>
      <template v-slot:left>
        <div class="col-lg-3">
          <UserFeedInfoVue
            ref="userFeed"
            props_selectItem="FeedCloud"
          ></UserFeedInfoVue>
        </div>
      </template>
      <template v-slot:content>
        <div class="col pool-fm">
          <!-- 排序按鈕 -->
                    <div class="sorting-fm">
            <div class="sorting">
          {{ $t('Social.FeedCloud.sorting') }}
              <a
                id="sorting-latest"
                @click="sort = 1"
                :class="{ current: sort == 1 }"
              >
                <span>{{ $t('Social.FeedCloud.newvideo') }}</span>
              </a>
              <a
                id="sorting-hottest"
                @click="sort = 2"
                :class="{ current: sort == 2 }"
              >
                <span>{{ $t('Social.FeedCloud.hitvideo') }}</span>
              </a>
            </div>
          </div>
          <div v-if="sort == 1" class="ld" v-loading="loading">
            <div class="pool-fm row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
              <div
                class="pool-cloud fm-set col"
                v-for="item in pageData"
                :key="item.id"
              >
                <singleVideoVue
                  :id="item.id"
                  :url="item.fileShareUrl"
                  :avatar="item.userLogoBig"
                  :authorName="item.sgL_MyVideoName"
                  :displayName="item.sgL_UsersName"
                  :date="item.sgL_PG_CAddTimerI"
                  :lookCount="item.sgL_PG_CTotalView"
                  :title="item.sgL_Title"
                  :likeCount="item.sgL_PG_CTotalLike"
                  :poster="item.sgL_ImageTempURL"
                  :poster2="item.jietuFileUrl"
                  @viewData="$parent.viewInfo(item)"
                  @like="$parent.likeFunc(item, item.sgL_IsLike)"
                  :item="item"
                >
                  <template v-slot:SpecifyMenu>
                    <moreMenuVue @ck="$parent.copyLink(item.id)">
                      <template v-slot:icon>
                        <i class="fa fa-clone mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.clone') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.collectFunc(item)">
                      <template v-slot:icon>
                        <i
                          v-if="item.sgL_IsFavorite"
                          class="fas fa-bookmark fa-fw"
                        ></i>
                        <i v-else class="far fa-bookmark mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.bookmark') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.updateStatistics(item, 50)">
                      <template v-slot:icon>
                        <i class="fa fa-share mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.share') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.reportFunc(item)">
                      <template v-slot:icon>
                        <i class="far fa-flag mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.flag') }} </template>
                    </moreMenuVue>
                  </template>
                </singleVideoVue>
              </div>
            </div>
            <div class="row rowTop">
              <div class="col">
                <pagination
                  v-if="pageData != null && pageData.length > 0"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  :hide-on-single-page="true"
                  :pageSizes="pageParams.pageSizes"
                  @handleCurrentChange="handleCurrent"
                  @handleSizeChange="handleSize"
                />
              </div>
            </div>
          </div>
          <div v-if="sort == 2" class="ld" v-loading="loading2">
            <div class="pool-fm row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
              <div
                class="pool-cloud fm-set col"
                v-for="item in pageData2"
                :key="item.id"
              >
                <singleVideoVue
                  :id="item.id"
                  :url="item.fileShareUrl"
                  :avatar="item.userLogoBig"
                  :authorName="item.sgL_MyVideoName"
                  :displayName="item.sgL_UsersName"
                  :date="item.sgL_PG_CAddTimerI"
                  :lookCount="item.sgL_PG_CTotalView"
                  :title="item.sgL_Title"
                  :likeCount="item.sgL_PG_CTotalLike"
                  :poster="item.sgL_ImageTempURL"
                  :poster2="item.jietuFileUrl"
                  :item="item"
                  @viewData="$parent.viewInfo(item)"
                  @like="$parent.likeFunc(item, item.sgL_IsLike)"
                >
                  <template v-slot:SpecifyMenu>
                    <moreMenuVue @ck="$parent.copyLink(item.id)">
                      <template v-slot:icon>
                        <i class="fa fa-clone mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.clone') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.collectFunc(item)">
                      <template v-slot:icon>
                        <i
                          v-if="item.sgL_IsFavorite"
                          class="fas fa-bookmark fa-fw"
                        ></i>
                        <i v-else class="far fa-bookmark mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.bookmark') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.updateStatistics(item, 50)">
                      <template v-slot:icon>
                        <i class="fa fa-share mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.share') }} </template>
                    </moreMenuVue>
                    <moreMenuVue @ck="$parent.reportFunc(item)">
                      <template v-slot:icon>
                        <i class="far fa-flag mr-1"></i>
                      </template>
                      <template v-slot:txt> {{ $t('Social.FeedCloud.flag') }} </template>
                    </moreMenuVue>
                  </template>
                </singleVideoVue>
              </div>
            </div>
            <div class="row rowTop">
              <div class="col">
                <pagination
                  v-if="pageData2 != null && pageData2.length > 0"
                  :currentPage="pageParams2.currentPage"
                  :total="pageParams2.total"
                  :limit="pageParams2.limit"
                  :small="true"
                  :hide-on-single-page="true"
                  :pageSizes="pageParams2.pageSizes"
                  @handleCurrentChange="handleCurrent2"
                  @handleSizeChange="handleSize2"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </TempPageVue>
  </div>
</template>

<script>
import TempPageVue from "./TempPage.vue";
import UserFeedInfoVue from "./UserFeedInfo.vue";
import singleVideoVue from "./singleVideo.vue";
import moreMenuVue from "./moreMenu.vue";
import pagination from "../common/Page";

export default {
  components: {
    TempPageVue,
    UserFeedInfoVue,
    singleVideoVue,
    moreMenuVue,
    pagination,
  },
  data() {
    return {
      loading: false,
      loading2: false,
      sort: 1,
      pageData: [],
      pageData2: [],
      pageParams: {
        currentPage: 1,
        limit: 6,
        total: 0,
        pageSizes: [3, 6, 12, 24],
      },
      pageParams2: {
        currentPage: 1,
        limit: 6,
        total: 0,
        pageSizes: [3, 6, 12, 24],
      },
      loadOptions: {},
    };
  },
  created() {
    this.getPageData();
  },
  methods: {
    handleCurrent2(val) {
      this.pageParams2.currentPage = val;
      this.getPageData2();
    },
    handleSize2(val) {
      this.pageParams2.limit = val;
      this.pageParams2.currentPage = 1;
      this.getPageData2();
    },
    handleCurrent(val) {
      this.pageParams.currentPage = val;
      this.getPageData();
    },
    handleSize(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getPageData();
    },
    getPageData(isRefresh) {
      //this.pageData = [];
      this.loading = true;
      if (isRefresh) {
        this.pageParams.currentPage = 1;
      }
      let params = {
        SGL_IsShow: 1,
        SGL_Type: 0,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_UserID: this.$route.query.uid,
      };
      this.$api.social.GetSocialData(params).then((res) => {
        if (res.data.success) {
          window.scrollTo(0, 0);
          this.loading = false;
          this.pageData = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    getPageData2() {
      //this.pageData2 = [];
      this.loading2 = true;
      let params = {
        SGL_IsShow: 1,
        SGL_Type: 0,
        Sorting: "HotCount",
        SkipCount: (this.pageParams2.currentPage - 1) * this.pageParams2.limit,
        MaxResultCount: this.pageParams2.limit,
      };
      this.$api.social.GetSocialData(params).then((res) => {
        if (res.data.success) {
          window.scrollTo(0, 0);
          this.loading2 = false;
          this.pageData2 = res.data.result.items;
          this.pageParams2.total = res.data.result.totalCount;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
  },
};
</script>

<style scoped>
.sorting-fm {
  display: flex;
}
.sorting-fm div:nth-child(2) {
  flex: 1;
  text-align: right;
}

.sorting a {
  padding: 6px 8px;
  border-radius: initial;
}

.ld {
  position: relative;
}
.rowTop {
  margin-top: 30px;
}

.pool-fm >>> .el-loading-mask {
  background-color: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/FeedPerson.vue